module.exports = __webpack_public_path__ + "img/consulting.f59f48ae.png";